export default "__VITE_ASSET__ChgXu_Vg__"